import { fetchFromOldApi } from '~/services/Http';

export interface TimeSheet {
  extraHoursBalance: string;
}

export const GET_TIMESHEET_SWR_KEY = 'getTimeSheet';
export const getTimeSheet = (employeeId: number): Promise<TimeSheet> => {
  return fetchFromOldApi(`/json/timesheet/employee/${employeeId}/timesheet`)
    .then((r) => r.json())
    .then((r) => r || { extraHoursBalance: 'PT0M' });
};

export enum ReportingGroupType {
  TIMESHEET_WORK_TYPE = 'TIMESHEET_WORK_TYPE',
  TIMESHEET_NON_WORK_TYPE = 'TIMESHEET_NON_WORK_TYPE',
  TIMESHEET_CORRECTION_TYPE = 'TIMESHEET_CORRECTION_TYPE',
}

export interface TimeBlock {
  id?: number;
  reportingType: string;
  reportingGroupType: ReportingGroupType;
  from?: string;
  to?: string;
  hours: string;
  customData: object;
}

export interface TimeCard<TB = TimeBlock> {
  date: string;
  requiredWorkingHours: string;
  comment: string;
  timeBlocks: TB[];
}

export const getTimeCards = (
  employeeId: number,
  startDate: string,
  endDate: string,
): Promise<TimeCard[]> => {
  return fetchFromOldApi(
    `/json/timesheet/employee/${employeeId}/timecards?startDate=${startDate}&endDate=${endDate}`,
  )
    .then((r) => r.json())
    .then((r) => r.data);
};

export type TimeCardUpdate = TimeCard<
  Omit<TimeBlock, 'hours'> & { hours?: string }
>;

export const updateTimeCard = (
  employeeId: number,
  timeCard: TimeCardUpdate,
): Promise<TimeCard> => {
  return fetchFromOldApi(`/json/timesheet/employee/${employeeId}/timecard`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(timeCard),
  }).then((r) => r.json());
};

export interface HoursSettings {
  workDayHours: string;
  maxCumulativeHours: string;
  blockAfterDays: number;
}

export const getCountryHoursSettings = (
  countryCode: string,
): Promise<HoursSettings> => {
  return fetchFromOldApi(`/json/timesheet/region-settings/${countryCode}`)
    .then((r) => r.json())
    .catch((r) => {
      if (r.status !== 404) {
        throw r;
      }
    });
};

export const getPrevTimeCardWorkingHours = (
  employeeId: number,
  date: string,
): Promise<string | undefined> => {
  return fetchFromOldApi(
    `/json/timesheet/employee/${employeeId}/workhours/${date}/default`,
  )
    .then((r) => r.json())
    .then((r) => r.hours)
    .catch((r) => {
      if (r.status !== 404) {
        throw r;
      }
    });
};

export const getAutoDeduction = (
  employeeId: number,
): Promise<string | null> => {
  return fetchFromOldApi(`/json/timesheet/autodeduction/${employeeId}`)
    .then((r) => r.json())
    .then((r) => r.duration)
    .catch((r) => {
      if (r.status !== 404) {
        throw r;
      }
    });
};
